import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

export default (function (clientType, websocketUri, applicationType, params) {
  return new Promise(function (resolve, reject) {
    try {
      // @ts-ignore
      import('socket.io-client').then(function (socketClient) {
        var socket = socketClient.default(websocketUri, {
          query: _objectSpread({
            type: 'TOKEN',
            clientType: clientType,
            applicationType: applicationType
          }, params),
          transports: ['websocket']
        });
        socket.on('connect', function () {
          resolve(socket);
        });
      });
    } catch (e) {
      reject(e);
    }
  });
});
//# sourceMappingURL=socketConnection.js.map